import Content from "components/Content";
import Label from "components/Label";
import React, { FC } from "react";

import styles from "./styles.module.scss";

const MainHeader: FC = () => {
  return (
    <Content
      contentClassName={styles.container}
      containerClassName={styles.wrapper}
    >
      <div className={styles.content}>
        <Label
          variant="s-capitalized"
          color="supplemental"
          className={styles.eyebrow}
        >
          Humming Homes Blog
        </Label>
        <div className={styles.titleWrapper}>
          <Label className={styles.title} variant="h" color="lightPrimary">
            Home Maintenance & Improvement Expertise, at your fingertips
          </Label>
        </div>
        <div className={styles.subtitleWrapper}>
          <Label className={styles.subtitle} variant="s" color="lightPrimary">
            We&apos;re industry experts, with a focus on ensuring any homeowner
            has the perfect set of information related to home services. From
            guides, to expert advice to comparisons, we&apos;ve got you covered.
          </Label>
        </div>
      </div>
    </Content>
  );
};

export default MainHeader;
